import { render, staticRenderFns } from "./ProfileNavItem.vue?vue&type=template&id=036e342e&scoped=true"
import script from "./ProfileNavItem.vue?vue&type=script&lang=js"
export * from "./ProfileNavItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileNavItem.vue?vue&type=style&index=0&id=036e342e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e342e",
  null
  
)

export default component.exports